import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { AutoRotateModuleComponent } from './code-split/auto-rotate-module-component';
import { ModuleProps } from 'src/utils/module-util';

const AutoRotateModule: React.FC<ComponentLayoutType<any>> = (props) => {
  return ( 
    <ComponentLayout {...props}>
      <AutoRotateModuleComponent data={undefined} />
    </ComponentLayout>
  );
};

export default AutoRotateModule;

const AutoRotateImageModule = (props: ModuleProps) => {  
  const componentLayoutType: ComponentLayoutType<any> = {
    moduleName: 'auto-rotate-module',
    data: props?.data
  };  

  return <AutoRotateModule {...componentLayoutType}/>;
};

export { AutoRotateImageModule };
